export const sectionBlockStyles = {
	root: (touchEditVisible: boolean) => ({
		my: 0,
		px: 2,
		'& [data-section-controls]': {
			opacity: touchEditVisible ? 1 : 0,
			pointerEvents: touchEditVisible ? 'auto' : 'none',
			transition: 'opacity 120ms ease-in-out'
		},
		'@media (hover: hover)': {
			'&:hover [data-section-controls], &:focus-within [data-section-controls]':
				{
					opacity: 1,
					pointerEvents: 'auto'
				}
		},
		'&:has([data-force-visible]) [data-section-controls]': {
			opacity: 1,
			pointerEvents: 'auto'
		}
	}),

	headerRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between'
	},

	titleGroup: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: 1
	},

	title: {
		fontWeight: 700,
		fontSize: '1.25rem',
		color: 'text.fadedPrimary',
		lineHeight: '160%',
		letterSpacing: '0.15px',
		mb: 1
	},

	titleAdornment: {
		mb: 1
	},

	controls: (offsetControls: boolean) => ({
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'flex-end',
		gap: 1,
		...(offsetControls && {
			marginTop: '-22px',
			marginRight: '-4px'
		})
	}),

	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2
	}
};
